import isSuggestionPillInSearchBox from '../selectors/isSuggestionPillInSearchBox';
import {
    addSuggestionPill,
    onSearchTextChanged,
    setSearchTextForSuggestion,
} from '../actions/publicActions';
import { addSuggestionPillInternal } from '../actions/internalActions';
import { orchestrator } from 'satcheljs';
import { PillSuggestion } from 'owa-search-service';

export default orchestrator(addSuggestionPill, actionMessage => {
    const scenarioId = actionMessage.scenarioId;
    const suggestionPill: PillSuggestion = actionMessage.suggestionPill;

    // If payload is invalid then bail.
    if (!suggestionPill) {
        return;
    }

    /**
     * Only add suggestion to collection of suggestion pills if it hasn't already
     * been added.
     */
    if (!isSuggestionPillInSearchBox(suggestionPill, scenarioId)) {
        /**
         * Add the suggestion pill to the collection, as well as adding its ID to
         * the array of IDs to maintain order.
         */
        addSuggestionPillInternal(suggestionPill, scenarioId);
    }

    // Clear search text (since suggestion pill was picked based on search text).
    if (actionMessage.suggestionSelected) {
        onSearchTextChanged('', scenarioId);
        setSearchTextForSuggestion('', scenarioId);
    }
});
